/* global window */

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// third party
import moment from 'moment';

// components
import CardTitlePart from '../../parts/CardTitlePart';
import HtmlPart from '../../parts/HtmlPart';
import TextCTA from '../../layout/buttons/TextCTA';
import DatePicker from '../../parts/DatePicker';
import SofaRescueLogo from '../../layout/graphics/SofaRescueLogo'
import OverlayLoader from '../../parts/OverlayLoader';
import SuccessConfirmationOverlay from '../../parts/SuccessConfirmationOverlay';
import FailureOverlay from '../../parts/FailureOverlay';

// actions
import { setCollectionDate } from '../../actions/sofarescue';
import { getEvents } from '../../actions/cardEvents';

import { gtmCardEvent, gtmSimplePageLoadEvent } from '../../services/gtmService';

class _BookDeliveryCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedDate: false,
      loadState: false
    };
    if(props.parentCardName && props.parentCardName === 'DeliveryFlow') {
      gtmSimplePageLoadEvent(`${props.parentCardName} page ${props.thisCardName}`);
    }
    this.handleSelect = this.handleSelect.bind(this);
    this.handleBookDelivery = this.handleBookDelivery.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
  }

  handleSelect(selectedDate) {
    gtmCardEvent('book-delivery', 'click-day', selectedDate.delDate.format('DD/MM/YYY'))();
    // this.setState({
    //   selectedDate
    // });
    // firing booking directly because michelle is now a ux designer
    // even though this is now the only card in the flow without a next button
    // and it is buggy and easy to accidentally click on swipe or scroll
    // and the back button is currently a bit cack.
    this.handleBookDelivery(selectedDate);
  }

  handleSuccess(res) {
    this.setState({ loadState: 'success' });
    return res;
  }

  handleError() {
    this.setState({ loadState: 'failure' });
    window.setTimeout(() => {
      this.setState({ loadState: false });
    }, 5000);
  }

  handleBookDelivery(selectedDate) {
    const { orderIdx, id, groupId, pushQueue, queueMessage,
      getEvents, setCollectionDate } = this.props;
    gtmCardEvent('book-delivery', 'click-next', selectedDate.delDate.format('DD/MM/YYY'))();
    this.setState({ loadState: 'loading' });

    setCollectionDate(orderIdx, selectedDate,
      id, groupId, pushQueue, queueMessage)
      .then(() => this.handleSuccess())
      .then(getEvents)
      .catch(() => this.handleError());
  }

  render() {
    const { deliverySchedules = [], title, titleColour, bodyText, orderRef, orderNo, contactNumber } = this.props;
    const dates = deliverySchedules.map(date => ({ ...date, delDate: moment(date.delDate) }));
    return (
      <div>

        <CardTitlePart backgroundColor={titleColour} title={`${title}`} />

        <div style={{ width: '100%' }} className="u-position-relative">
			<div style={{ width: '100%' }} className="u-pale-grey-bg u-position-relative">
				<br/>
				<div align="center">
          <img 
            alt='Sofa Rescue'
            src="https://images.sofology.co.uk/image/upload/v1583840490/MySofologyAssets/sofarescue_card_logo.jpg"
          />
          </div>
				
				<div className="u-text-center u-padding-top-small u-padding-bottom-small">
						What date would you like us to <br />
						collect your old sofa?
				  </div>
				  
			</div>
          <DatePicker
            dates={dates}
            contactNumber={contactNumber}
            onSelect={this.handleSelect}
            deliveryDateCutOff={this.props.deliveryDateCutOff}
            isCovidWhiteListed={this.props.IsCovidWhiteListed}
            isApolloOrder={this.props.IsApolloOrder}
			      showEcoDates={false}
			      extraClass={'eco'}
          />

          <OverlayLoader active={this.state.loadState === 'loading'} scale={1} background={'rgba(247,247,247, 0.7)'} />

          {this.state.loadState === 'success' ? <SuccessConfirmationOverlay /> : null}
          {this.state.loadState === 'failure' ? <FailureOverlay alpha={1} /> : null}

        </div>

        <div className="u-padding-medium u-padding-top-small u-padding-bottom-small">
          <HtmlPart htmlString={bodyText} />
        </div>

        <div className="u-padding-bottom-small u-text-center c-event-feed__card__extra-info">
          <strong>Order Number:</strong> {`${orderRef}/${orderNo}`}
        </div>

      </div>
    );
  }

}

const mapDispatchToProps = dispatch => bindActionCreators({
  setCollectionDate, getEvents
}, dispatch);

export default connect(null, mapDispatchToProps)(_BookDeliveryCard);



// WEBPACK FOOTER //
// ./src/cards/templates/SofaRescueBookingCard.js